import { useNavigate } from "react-router-dom";
import { logout } from "../../redux/auth/actions";
import { useEffect, useRef, useState } from "react";
import storePersist from "../../redux/storePersist";
import { useSelector } from "react-redux";
import { selectCurrent } from "../../redux/settings/selectors";
import { useAppDispatch } from "../../hooks/hooks";
import { settings } from "../../redux/settings/actions";
import useWindowDimensions from "../../hooks/useWindowsDimensions";
import { selectListItems } from "../../redux/organizationUnits/selector";

const Sidebar = () => {
  let items: any = []
	let subitems: any = []
	let menuitems: any = []
  const dropdownRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
	const result = useSelector(selectCurrent)
  const [logo, setLogo] = useState<any>()
  const [color, setColor] = useState('universal')
  const { header, footer, visible, sidebar,theme,primary ,secondary} = result
	const [activeIndex, setActiveIndex] = useState(null);
	const [activeSubIndex, setActiveSubIndex] = useState(null);
  const { height, width } = useWindowDimensions();
  const organizationLists= useSelector(selectListItems)
	const [menus, setMenus] = useState([
		// {
    //     id: `main-menu-2-all`,
    //     path: '/management/platform-management/opennetwork-domains',
    //     label: 'DBN Management',
    //     isEnabled:true,
    //     svg:(
    //       <svg className="h-6 w-6 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="white">
    //       <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 12a9 9 0 0 1-9 9c-4.97 0-9-4.03-9-9s4.03-9 9-9 9 4.03 9 9zm-7-5v6l3 3v-6"></path>
    //     </svg>
  
    //     ),
        
    //     Description:'eAdvisor is a enterprise dashboard and reports to visualize key metrics and data in one centralized location, allowing you to monitor and analyze information at a glance. Use our comprehensive reports to uncover trends, identify opportunities, and drive growth.',
    //     subMenu: [
    //       {
    //         id: `coln-1-collections`,
    //         label: 'Global Registrations',
    //         path: '/management/organization/dbn/global-org-registrations',
    //         isEnabled:true,
    //         svg:(
    //           <svg className="h-6 w-6 mr-1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    //           <path d="M18.7304 14.6701L14.5804 18.8201C14.4204 18.9801 14.2704 19.2901 14.2304 19.5101L14.0004 21.1001C13.9204 21.6701 14.3204 22.0801 14.8904 21.9901L16.4804 21.7601C16.7004 21.7301 17.0104 21.5701 17.1704 21.4101L21.3204 17.2601C22.0304 16.5501 22.3704 15.7101 21.3204 14.6601C20.2804 13.6201 19.4504 13.9501 18.7304 14.6701Z" fill="currentColor"></path>
    //           <path d="M18.1406 15.2603C18.4906 16.5203 19.4806 17.5002 20.7406 17.8602L18.1406 15.2603Z" fill="currentColor"></path>
    //           <path d="M2.02977 14.6299C2.02977 14.6599 2.00977 14.6999 2.00977 14.7299C2.92977 16.5699 4.42978 18.0799 6.26978 18.9899C6.29978 18.9899 6.33977 18.9699 6.36977 18.9699C6.02977 17.8099 5.76977 16.6199 5.57977 15.4299C4.37977 15.2299 3.18977 14.9699 2.02977 14.6299Z" fill="currentColor" opacity="0.4"></path>
    //           <path d="M19.0701 6.42993C18.1301 4.45993 16.5401 2.86994 14.5801 1.93994C14.9401 3.12994 15.2401 4.34995 15.4401 5.56995C16.6601 5.76995 17.8801 6.05993 19.0701 6.42993Z" fill="currentColor" opacity="0.4"></path>
    //           <path d="M1.92969 6.43002C3.12969 6.07002 4.3497 5.77004 5.5697 5.57004C5.7697 4.38004 6.0197 3.20004 6.3597 2.04004C6.3297 2.04004 6.28969 2.02002 6.25969 2.02002C4.37969 2.95002 2.84969 4.52002 1.92969 6.43002Z" fill="currentColor" opacity="0.4"></path>
    //           <path d="M13.8197 5.36023C13.5797 4.06023 13.2797 2.76024 12.8497 1.50024C12.8297 1.43024 12.8297 1.37025 12.8197 1.29025C12.0797 1.11025 11.2997 0.990234 10.4997 0.990234C9.68969 0.990234 8.91969 1.10025 8.16969 1.29025C8.15969 1.36025 8.16969 1.42024 8.14969 1.50024C7.72969 2.76024 7.41969 4.06023 7.17969 5.36023C9.38969 5.12023 11.6097 5.12023 13.8197 5.36023Z" fill="currentColor" opacity="0.4"></path>
    //           <path d="M5.36023 7.18018C4.05023 7.42018 2.76023 7.72018 1.50023 8.15018C1.43023 8.17018 1.37022 8.17018 1.29022 8.18018C1.11022 8.92018 0.990234 9.70018 0.990234 10.5002C0.990234 11.3102 1.10022 12.0802 1.29022 12.8302C1.36022 12.8402 1.42023 12.8302 1.50023 12.8502C2.76023 13.2702 4.05023 13.5802 5.36023 13.8202C5.12023 11.6102 5.12023 9.39018 5.36023 7.18018Z" fill="currentColor" opacity="0.4"></path>
    //           <path d="M19.7009 8.18018C19.6309 8.18018 19.5709 8.17018 19.4909 8.15018C18.2309 7.73018 16.9309 7.42018 15.6309 7.18018C15.8809 9.39018 15.8809 11.6102 15.6309 13.8102C16.9309 13.5702 18.2309 13.2702 19.4909 12.8402C19.5609 12.8202 19.6209 12.8302 19.7009 12.8202C19.8809 12.0702 20.0009 11.3002 20.0009 10.4902C20.0009 9.70017 19.8909 8.93018 19.7009 8.18018Z" fill="currentColor" opacity="0.4"></path>
    //           <path d="M7.17969 15.6401C7.41969 16.9501 7.71969 18.2401 8.14969 19.5001C8.16969 19.5701 8.15969 19.6301 8.16969 19.7101C8.91969 19.8901 9.68969 20.0101 10.4997 20.0101C11.2997 20.0101 12.0797 19.9001 12.8197 19.7101C12.8297 19.6401 12.8297 19.5801 12.8497 19.5001C13.2697 18.2401 13.5797 16.9501 13.8197 15.6401C12.7197 15.7601 11.6097 15.8501 10.4997 15.8501C9.38969 15.8401 8.27969 15.7601 7.17969 15.6401Z" fill="currentColor" opacity="0.4"></path>
    //           <path d="M6.94961 6.9501C6.64961 9.3101 6.64961 11.6901 6.94961 14.0601C9.30961 14.3601 11.6896 14.3601 14.0596 14.0601C14.3596 11.7001 14.3596 9.3201 14.0596 6.9501C11.6896 6.6501 9.30961 6.6501 6.94961 6.9501Z" fill="currentColor" opacity="0.4"></path>
    //         </svg>
      
    //         ),
    //       },
    //       {
    //         id: `coln-1-collections`,
    //         label: 'Domains',
    //         path: '/management/platform-management/opennetwork-domains',
    //         isEnabled:true,
    //         svg:(
    //           <svg className="h-5 w-5 mr-1" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" fill="none">
    //           <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.903 8c.06.629.097 1.292.097 2a1 1 0 01-2 0c0-.713-.039-1.378-.105-2H8.092c-.139 1.33-.14 2.67-.004 4H10a1 1 0 010 2H8.416c.469 2.08 1.202 3.41 1.585 4 0 0 .789.013.926.002a1.008 1.008 0 011.07.925 1 1 0 01-.924 1.07C10.979 20.004 10 20 10 20 4.486 20 0 15.514 0 10 0 4.485 4.486 0 10 0s10 4.485 10 10c0 .379-.036.749-.079 1.116a1.001 1.001 0 01-1.987-.233c.035-.291.066-.583.066-.883 0-.692-.098-1.36-.263-2h-3.834zM9.988 2.036c-.386.606-1.1 1.931-1.564 3.964h3.137c-.466-2.033-1.185-3.358-1.573-3.964zM2.263 12h3.819a21.604 21.604 0 01-.095-1.996c0-.67.033-1.338.096-2.004h-3.82A7.946 7.946 0 002 10a7.96 7.96 0 00.263 2zm.819 2a8.031 8.031 0 004.437 3.601A16.293 16.293 0 016.371 14H3.082zm3.291-8a16.235 16.235 0 011.15-3.603A8.03 8.03 0 003.082 6h3.291zm7.239 0h3.305a8.029 8.029 0 00-4.465-3.612A16.128 16.128 0 0113.612 6z"></path>
    //           <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.223 18.945l-2.55-5.61a.5.5 0 01.662-.662l5.61 2.55a.5.5 0 01.017.903l-1.742.87a.5.5 0 00-.223.224l-.871 1.742a.5.5 0 01-.903-.017z"></path>
    //         </svg>
      
    //         ),
    //       },
    //       {
    //         id: `coln-1-collections`,
    //         label: 'Categories',
    //         path: '/management/platform-management/opennetwork-categories',
    //         isEnabled:true,
    //         svg:(
    //           <svg className="h-5 w-5 mr-1" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    //           <rect x="6" y="28" width="36" height="14" rx="4" stroke="currentColor" stroke-width="4"></rect>
    //           <path d="M20 7H10C7.79086 7 6 8.79086 6 11V17C6 19.2091 7.79086 21 10 21H20" stroke="currentColor" stroke-width="4" stroke-linecap="round"></path>
    //           <circle cx="34" cy="14" r="8" fill="currentColor" stroke="currentColor" stroke-width="4"></circle>
    //           <circle cx="34" cy="14" r="3" fill="currentColor"></circle>
    //         </svg>
      
    //         ),
    //       },
    //       {
    //         id: `coln-1-collections`,
    //         label: 'Product Types',
    //         path: '/management/platform-management/opennetwork-product-types',
    //         isEnabled:true,
    //         svg:(
    //           <svg className="h-5 w-5 mr-1" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none">
    //           <path fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" d="M10 4V2H2V10H4V6C4 4.89543 4.89543 4 6 4H10zM12 4H14C15.1046 4 16 4.89543 16 6V14C16 15.1046 15.1046 16 14 16H6C4.89543 16 4 15.1046 4 14V12H2C0.89543 12 0 11.1046 0 10V2C0 0.89543 0.89543 0 2 0H10C11.1046 0 12 0.89543 12 2V4zM6 6V14H14V6H6z"/>
    //         </svg>
      
    //         ),
    //       },
    //     ],
    //   },
      {
        id: `main-menu-2-all`,
        path: '/management/platform-management/businesses',
        label: 'Business Management',
        isEnabled:true,
        svg:(
          <svg className="h-7 w-7 text-white" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#FFFFFF">
  <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
  <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
  <g id="SVGRepo_iconCarrier">
    <title></title>
    <g id="Card">
      <path  d="M21,17H20V12a1,1,0,0,0-1-1H13V7h1a1,1,0,0,0,1-1V3a1,1,0,0,0-1-1H10A1,1,0,0,0,9,3V6a1,1,0,0,0,1,1h1v4H5a1,1,0,0,0-1,1v5H3a1,1,0,0,0-1,1v3a1,1,0,0,0,1,1H7a1,1,0,0,0,1-1V18a1,1,0,0,0-1-1H6V13h5v4H10a1,1,0,0,0-1,1v3a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V18a1,1,0,0,0-1-1H13V13h5v4H17a1,1,0,0,0-1,1v3a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V18A1,1,0,0,0,21,17ZM11,4h2V5H11ZM6,20H4V19H6Zm7,0H11V19h2Zm7,0H18V19h2Z"></path>
    </g>
  </g>
</svg>
  
        ),
        
        Description:'eAdvisor is a enterprise dashboard and reports to visualize key metrics and data in one centralized location, allowing you to monitor and analyze information at a glance. Use our comprehensive reports to uncover trends, identify opportunities, and drive growth.',
        subMenu: [
          {
            id: `coln-1-collections`,
            label: 'Business',
            path: '/management/platform-management/businesses',
            isEnabled:true,
            svg:(
              <svg className="h-6 w-6 mr-1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none">
              <path fill="currentColor" d="M21,17H20V12a1,1,0,0,0-1-1H13V7h1a1,1,0,0,0,1-1V3a1,1,0,0,0-1-1H10A1,1,0,0,0,9,3V6a1,1,0,0,0,1,1h1v4H5a1,1,0,0,0-1,1v5H3a1,1,0,0,0-1,1v3a1,1,0,0,0,1,1H7a1,1,0,0,0,1-1V18a1,1,0,0,0-1-1H6V13h5v4H10a1,1,0,0,0-1,1v3a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V18a1,1,0,0,0-1-1H13V13h5v4H17a1,1,0,0,0-1,1v3a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V18A1,1,0,0,0,21,17ZM11,4h2V5H11ZM6,20H4V19H6Zm7,0H11V19h2Zm7,0H18V19h2Z"/>
            </svg>
      
            ),
          },
          {
            id: `coln-1-collections`,
            label: 'Tenants',
            path: '/management/platform-management/tenants',
            isEnabled:true,
            svg:(
              <svg className="h-5 w-5 mr-1" xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12.25 12.5C12.25 13.6046 11.3546 14.5 10.25 14.5C9.14543 14.5 8.25 13.6046 8.25 12.5C8.25 11.3954 9.14543 10.5 10.25 10.5C11.3546 10.5 12.25 11.3954 12.25 12.5Z M14.25 4.5L20 10.1893V18H16.5V20H4V11.9393L10.25 5.68933L11.625 7.06433L14.25 4.5Z M18.5 10.8107V16.5H16.5V11.9393L12.6857 8.12499L14.25 6.56065L18.5 10.8107Z M5.5 12.5607V18.5H6.78545C7.02806 16.8038 8.48677 15.5 10.25 15.5C12.0132 15.5 13.4719 16.8038 13.7146 18.5H15V12.5607L10.25 7.81065L5.5 12.5607Z"/>
            </svg>
      
            ),
          },
          {
            id: `coln-1-collections`,
            label: 'Licenses',
            path: '/management/platform-management/licenses',
            isEnabled:true,
            svg:(
              <svg className="h-5 w-5 mr-1" xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12.25 12.5C12.25 13.6046 11.3546 14.5 10.25 14.5C9.14543 14.5 8.25 13.6046 8.25 12.5C8.25 11.3954 9.14543 10.5 10.25 10.5C11.3546 10.5 12.25 11.3954 12.25 12.5Z M14.25 4.5L20 10.1893V18H16.5V20H4V11.9393L10.25 5.68933L11.625 7.06433L14.25 4.5Z M18.5 10.8107V16.5H16.5V11.9393L12.6857 8.12499L14.25 6.56065L18.5 10.8107Z M5.5 12.5607V18.5H6.78545C7.02806 16.8038 8.48677 15.5 10.25 15.5C12.0132 15.5 13.4719 16.8038 13.7146 18.5H15V12.5607L10.25 7.81065L5.5 12.5607Z"/>
            </svg>
      
            ),
          },
          {
            id: `coln-1-collections`,
            label: 'Business Users',
            path: '/management/platform-management/business-users',
            isEnabled:true,
            svg:(
              <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M13 20V18C13 15.2386 10.7614 13 8 13C5.23858 13 3 15.2386 3 18V20H13ZM13 20H21V19C21 16.0545 18.7614 14 16 14C14.5867 14 13.3103 14.6255 12.4009 15.6311M11 7C11 8.65685 9.65685 10 8 10C6.34315 10 5 8.65685 5 7C5 5.34315 6.34315 4 8 4C9.65685 4 11 5.34315 11 7ZM18 9C18 10.1046 17.1046 11 16 11C14.8954 11 14 10.1046 14 9C14 7.89543 14.8954 7 16 7C17.1046 7 18 7.89543 18 9Z"/>
            </svg>
      
            ),
          },
        ],
      },
      {
        id: `main-menu-2-all`,
        path: '/management/platform-management/domains',
        label: 'Platform Management',
        isEnabled:true,
        svg:(
          <svg className="h-7 w-7 text-white" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#FFFFFF">
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
          <g id="SVGRepo_iconCarrier">
            <title></title>
            <g id="Card">
              <path  d="M21,17H20V12a1,1,0,0,0-1-1H13V7h1a1,1,0,0,0,1-1V3a1,1,0,0,0-1-1H10A1,1,0,0,0,9,3V6a1,1,0,0,0,1,1h1v4H5a1,1,0,0,0-1,1v5H3a1,1,0,0,0-1,1v3a1,1,0,0,0,1,1H7a1,1,0,0,0,1-1V18a1,1,0,0,0-1-1H6V13h5v4H10a1,1,0,0,0-1,1v3a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V18a1,1,0,0,0-1-1H13V13h5v4H17a1,1,0,0,0-1,1v3a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V18A1,1,0,0,0,21,17ZM11,4h2V5H11ZM6,20H4V19H6Zm7,0H11V19h2Zm7,0H18V19h2Z"></path>
            </g>
          </g>
        </svg>
  
        ),
        
        Description:'eAdvisor is a enterprise dashboard and reports to visualize key metrics and data in one centralized location, allowing you to monitor and analyze information at a glance. Use our comprehensive reports to uncover trends, identify opportunities, and drive growth.',
        subMenu: [
          {
            id: `coln-1-collections`,
            label: 'POP',
            path: '/management/platform-management/pop',
            isEnabled:true,
            svg:(
              <svg className="h-5 w-5 mr-1" 
             xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 14v4.833A1.166 1.166 0 0 1 16.833 20H5.167A1.167 1.167 0 0 1 4 18.833V7.167A1.166 1.166 0 0 1 5.167 6h4.618m4.447-2H20v5.768m-7.889 2.121 7.778-7.778"/>
      </svg>
      
            ),
          },
          {
            id: `coln-1-collections`,
            label: 'Domains',
            path: '/management/platform-management/domains',
            isEnabled:true,
            svg:(
              <svg className="h-5 w-5 mr-1" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" fill="none">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.903 8c.06.629.097 1.292.097 2a1 1 0 01-2 0c0-.713-.039-1.378-.105-2H8.092c-.139 1.33-.14 2.67-.004 4H10a1 1 0 010 2H8.416c.469 2.08 1.202 3.41 1.585 4 0 0 .789.013.926.002a1.008 1.008 0 011.07.925 1 1 0 01-.924 1.07C10.979 20.004 10 20 10 20 4.486 20 0 15.514 0 10 0 4.485 4.486 0 10 0s10 4.485 10 10c0 .379-.036.749-.079 1.116a1.001 1.001 0 01-1.987-.233c.035-.291.066-.583.066-.883 0-.692-.098-1.36-.263-2h-3.834zM9.988 2.036c-.386.606-1.1 1.931-1.564 3.964h3.137c-.466-2.033-1.185-3.358-1.573-3.964zM2.263 12h3.819a21.604 21.604 0 01-.095-1.996c0-.67.033-1.338.096-2.004h-3.82A7.946 7.946 0 002 10a7.96 7.96 0 00.263 2zm.819 2a8.031 8.031 0 004.437 3.601A16.293 16.293 0 016.371 14H3.082zm3.291-8a16.235 16.235 0 011.15-3.603A8.03 8.03 0 003.082 6h3.291zm7.239 0h3.305a8.029 8.029 0 00-4.465-3.612A16.128 16.128 0 0113.612 6z"></path>
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.223 18.945l-2.55-5.61a.5.5 0 01.662-.662l5.61 2.55a.5.5 0 01.017.903l-1.742.87a.5.5 0 00-.223.224l-.871 1.742a.5.5 0 01-.903-.017z"></path>
            </svg>
      
            ),
          },
          {
            id: `coln-1-collections`,
            label: 'DBAs',
            path: '/management/platform-management/dbas',
            isEnabled:true,
            svg:(
              <svg className="h-5 w-5 mr-1" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" fill="none">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.903 8c.06.629.097 1.292.097 2a1 1 0 01-2 0c0-.713-.039-1.378-.105-2H8.092c-.139 1.33-.14 2.67-.004 4H10a1 1 0 010 2H8.416c.469 2.08 1.202 3.41 1.585 4 0 0 .789.013.926.002a1.008 1.008 0 011.07.925 1 1 0 01-.924 1.07C10.979 20.004 10 20 10 20 4.486 20 0 15.514 0 10 0 4.485 4.486 0 10 0s10 4.485 10 10c0 .379-.036.749-.079 1.116a1.001 1.001 0 01-1.987-.233c.035-.291.066-.583.066-.883 0-.692-.098-1.36-.263-2h-3.834zM9.988 2.036c-.386.606-1.1 1.931-1.564 3.964h3.137c-.466-2.033-1.185-3.358-1.573-3.964zM2.263 12h3.819a21.604 21.604 0 01-.095-1.996c0-.67.033-1.338.096-2.004h-3.82A7.946 7.946 0 002 10a7.96 7.96 0 00.263 2zm.819 2a8.031 8.031 0 004.437 3.601A16.293 16.293 0 016.371 14H3.082zm3.291-8a16.235 16.235 0 011.15-3.603A8.03 8.03 0 003.082 6h3.291zm7.239 0h3.305a8.029 8.029 0 00-4.465-3.612A16.128 16.128 0 0113.612 6z"></path>
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.223 18.945l-2.55-5.61a.5.5 0 01.662-.662l5.61 2.55a.5.5 0 01.017.903l-1.742.87a.5.5 0 00-.223.224l-.871 1.742a.5.5 0 01-.903-.017z"></path>
            </svg>
      
            ),
          },
          {
            id: `coln-1-collections`,
            label: 'DBA Services',
            path: '/management/platform-management/platform-dba-services',
            isEnabled:true,
            svg:(
              <svg className="h-5 w-5 mr-1" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" fill="none">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.903 8c.06.629.097 1.292.097 2a1 1 0 01-2 0c0-.713-.039-1.378-.105-2H8.092c-.139 1.33-.14 2.67-.004 4H10a1 1 0 010 2H8.416c.469 2.08 1.202 3.41 1.585 4 0 0 .789.013.926.002a1.008 1.008 0 011.07.925 1 1 0 01-.924 1.07C10.979 20.004 10 20 10 20 4.486 20 0 15.514 0 10 0 4.485 4.486 0 10 0s10 4.485 10 10c0 .379-.036.749-.079 1.116a1.001 1.001 0 01-1.987-.233c.035-.291.066-.583.066-.883 0-.692-.098-1.36-.263-2h-3.834zM9.988 2.036c-.386.606-1.1 1.931-1.564 3.964h3.137c-.466-2.033-1.185-3.358-1.573-3.964zM2.263 12h3.819a21.604 21.604 0 01-.095-1.996c0-.67.033-1.338.096-2.004h-3.82A7.946 7.946 0 002 10a7.96 7.96 0 00.263 2zm.819 2a8.031 8.031 0 004.437 3.601A16.293 16.293 0 016.371 14H3.082zm3.291-8a16.235 16.235 0 011.15-3.603A8.03 8.03 0 003.082 6h3.291zm7.239 0h3.305a8.029 8.029 0 00-4.465-3.612A16.128 16.128 0 0113.612 6z"></path>
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.223 18.945l-2.55-5.61a.5.5 0 01.662-.662l5.61 2.55a.5.5 0 01.017.903l-1.742.87a.5.5 0 00-.223.224l-.871 1.742a.5.5 0 01-.903-.017z"></path>
            </svg>
      
            ),
          },
          {
            id: `coln-1-collections`,
            label: 'Gateways',
            path: '/management/platform-management/gateways',
            isEnabled:true,
            svg:(
              <svg className="h-5 w-5 mr-1" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" fill="none">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.903 8c.06.629.097 1.292.097 2a1 1 0 01-2 0c0-.713-.039-1.378-.105-2H8.092c-.139 1.33-.14 2.67-.004 4H10a1 1 0 010 2H8.416c.469 2.08 1.202 3.41 1.585 4 0 0 .789.013.926.002a1.008 1.008 0 011.07.925 1 1 0 01-.924 1.07C10.979 20.004 10 20 10 20 4.486 20 0 15.514 0 10 0 4.485 4.486 0 10 0s10 4.485 10 10c0 .379-.036.749-.079 1.116a1.001 1.001 0 01-1.987-.233c.035-.291.066-.583.066-.883 0-.692-.098-1.36-.263-2h-3.834zM9.988 2.036c-.386.606-1.1 1.931-1.564 3.964h3.137c-.466-2.033-1.185-3.358-1.573-3.964zM2.263 12h3.819a21.604 21.604 0 01-.095-1.996c0-.67.033-1.338.096-2.004h-3.82A7.946 7.946 0 002 10a7.96 7.96 0 00.263 2zm.819 2a8.031 8.031 0 004.437 3.601A16.293 16.293 0 016.371 14H3.082zm3.291-8a16.235 16.235 0 011.15-3.603A8.03 8.03 0 003.082 6h3.291zm7.239 0h3.305a8.029 8.029 0 00-4.465-3.612A16.128 16.128 0 0113.612 6z"></path>
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.223 18.945l-2.55-5.61a.5.5 0 01.662-.662l5.61 2.55a.5.5 0 01.017.903l-1.742.87a.5.5 0 00-.223.224l-.871 1.742a.5.5 0 01-.903-.017z"></path>
            </svg>
      
            ),
          },
          {
            id: `coln-1-collections`,
            label: 'Networks',
            path: '/management/dbaas/networks',
            isEnabled:true,
            svg:(
              <svg className="h-5 w-7 mr-1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 14v4.833A1.166 1.166 0 0 1 10.833 20H4.167A1.167 1.167 0 0 1 3 18.833V7.167A1.166 1.166 0 0 1 4.167 6h6.666m0-2H3v15.768m7.889 2.121-7.778-7.778"/>
            </svg>
      
            ),
          },
          {
            id: `coln-1-collections`,
            label: 'Applications',
            path: '/management/platform-management/applications',
            isEnabled:true,
            svg:(
              <svg className="h-7 w-6  mr-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 13H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2m-4 6h-4v-4h4v4zM10 4h4v4h-4V4zM20 4h-4v4h4V4zM20 10h-4v4h4v-4zM14 10h-4v4h4v-4zM8 10H4v4h4v-4z"/>
            </svg>
      
            ),
          },
          {
            id: `coln-1-collections`,
            label: 'Channels',
            path: '/management/platform-management/channels',
            isEnabled:true,
            svg:(
              <svg className="h-6 w-6  mr-1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3.5 8.5C3.5 7.94772 3.94772 7.5 4.5 7.5H12.5V9.5H4.5C3.94772 9.5 3.5 9.05228 3.5 8.5V8.5Z"/>
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14.5 7.5H19.5C20.0523 7.5 20.5 7.94772 20.5 8.5V8.5C20.5 9.05228 20.0523 9.5 19.5 9.5H14.5V7.5Z"/>
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3.5 12.5C3.5 11.9477 3.94772 11.5 4.5 11.5H9.5V13.5H4.5C3.94772 13.5 3.5 13.0523 3.5 12.5V12.5Z"/>
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11.5 11.5H19.5C20.0523 11.5 20.5 11.9477 20.5 12.5V12.5C20.5 13.0523 20.0523 13.5 19.5 13.5H11.5V11.5Z"/>
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3.5 16.5C3.5 15.9477 3.94772 15.5 4.5 15.5H15.5V17.5H4.5C3.94772 17.5 3.5 17.0523 3.5 16.5V16.5Z"/>
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.5 15.5H19.5C20.0523 15.5 20.5 15.9477 20.5 16.5V16.5C20.5 17.0523 20.0523 17.5 19.5 17.5H17.5V15.5Z"/>
            </svg>
            ),
          },
          {
            id: `coln-1-collections`,
            label: 'Features',
            path: '/management/platform-management/features',
            isEnabled:true,
            svg:(
              <svg className="h-5 w-6 mr-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M22.005 0c-.194-.002-.372.105-.458.276l-2.197 4.38-4.92.7c-.413.06-.578.56-.278.846l3.805 3.407-.953 4.81c-.07.406.363.715.733.523L22 12.67l4.286 2.273c.37.19.8-.118.732-.522l-.942-4.81 3.77-3.408c.3-.286.136-.787-.278-.846l-4.916-.7-2.2-4.38C22.368.11 22.195.002 22.005 0zM22 1.615l1.863 3.71c.073.148.216.25.38.273l4.168.595-3.227 2.89c-.12.112-.173.276-.145.436l.813 4.08-3.616-1.927c-.147-.076-.322-.076-.47 0l-3.59 1.926.823-4.08c.028-.16-.027-.325-.145-.438l-3.262-2.89 4.166-.594c.165-.023.307-.125.38-.272zM16.5 18c-.822 0-1.5.678-1.5 1.5v9c0 .822.678 1.5 1.5 1.5h9c.822 0 1.5-.678 1.5-1.5v-9c0-.822-.678-1.5-1.5-1.5zm0 1h9c.286 0 .5.214.5.5v9c0 .286-.214.5-.5.5h-9c-.286 0-.5-.214-.5-.5v-9c0-.286.214-.5.5-.5zM1.5 3C.678 3 0 3.678 0 4.5v9c0 .822.678 1.5 1.5 1.5h9c.822 0 1.5-.678 1.5-1.5v-9c0-.822-.678-1.5-1.5-1.5zm0 1h9c.286 0 .5.214.5.5v9c0 .286-.214.5-.5.5h-9c-.286 0-.5-.214-.5-.5v-9c0-.286.214-.5.5-.5zm0 14c-.822 0-1.5.678-1.5 1.5v9c0 .822.678 1.5 1.5 1.5h9c.822 0 1.5-.678 1.5-1.5v-9c0-.822-.678-1.5-1.5-1.5zm0 1h9c.286 0 .5.214.5.5v9c0 .286-.214.5-.5.5h-9c-.286 0-.5-.214-.5-.5v-9c0-.286.214-.5.5-.5z"/>
            </svg>
      
            ),
          },
          {
            id: `coln-1-collections`,
            label: 'Functions',
            path: '/management/platform-management/functions',
            isEnabled:true,
            svg:(
              <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 3h8v8H3V3zm0 10h8v8H3v-8zM13 3h8v8h-8V3zm0 10h8v8h-8v-8zm2-8v4h4V5h-4zm0 10v4h4v-4h-4zM5 5v4h4V5H5zm0 10v4h4v-4H5z"/>
            </svg>
      
            ),
          },
          {
            id: `coln-1-collections`,
            label: 'Entities',
            path: '/management/platform-management/entities',
            isEnabled:true,
            svg:(
              <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 3h8v8H3V3zm0 10h8v8H3v-8zM13 3h8v8h-8V3zm0 10h8v8h-8v-8zm2-8v4h4V5h-4zm0 10v4h4v-4h-4zM5 5v4h4V5H5zm0 10v4h4v-4H5z"/>
            </svg>
      
            ),
          },
          {
            id: `coln-1-collections`,
            label: 'Libraries',
            path: '/management/platform-management/library',
            isEnabled:true,
            svg:(
              <svg className="h-5 w-5 mr-1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 3h8v8H3V3zm0 10h8v8H3v-8zM13 3h8v8h-8V3zm0 10h8v8h-8v-8zm2-8v4h4V5h-4zm0 10v4h4v-4h-4zM5 5v4h4V5H5zm0 10v4h4v-4H5z"/>
            </svg>
      
            ),
          },
          {
            id: `coln-1-collections`,
            label: 'RBAC',
            path: '/management/platform-management/rbac',
            isEnabled:true,
            svg:(
              <svg className="h-5 w-5 mr-1" 
              xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
         <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 14v4.833A1.166 1.166 0 0 1 16.833 20H5.167A1.167 1.167 0 0 1 4 18.833V7.167A1.166 1.166 0 0 1 5.167 6h4.618m4.447-2H20v5.768m-7.889 2.121 7.778-7.778"/>
       </svg>
      
            ),
          },
        ],
      },
      {
        id: `main-menu-2-all`,
        path: '/management/dbaas/programs',
        label: 'DBaaS Management',
        isEnabled:true,
        svg:(
          <svg className="h-6 w-6 mr-1"  fill="#ffffff" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
          <path d="M4 26.016q0 1.632 1.6 3.008t4.384 2.176 6.016 0.8 6.016-0.8 4.384-2.176 1.6-3.008v-3.392q0 1.632-1.632 2.88t-4.32 1.856-6.048 0.64-6.048-0.64-4.32-1.856-1.632-2.88v3.392zM4 20q0 1.632 1.6 3.008t4.384 2.208 6.016 0.8 6.016-0.8 4.384-2.208 1.6-3.008v-3.36q0 1.6-1.632 2.848t-4.32 1.888-6.048 0.64-6.048-0.64-4.32-1.888-1.632-2.848v3.36zM4 14.016q0 1.632 1.6 3.008t4.384 2.176 6.016 0.8 6.016-0.8 4.384-2.176 1.6-3.008v-3.392q0 1.632-1.632 2.88t-4.32 1.856-6.048 0.64-6.048-0.64-4.32-1.856-1.632-2.88v3.392zM4 8q0 1.632 1.6 3.008t4.384 2.208 6.016 0.8 6.016-0.8 4.384-2.208 1.6-3.008v-1.984q0-1.632-1.6-3.008t-4.384-2.176-6.016-0.832-6.016 0.832-4.384 2.176-1.6 3.008v1.984z"/>
        </svg>
  
        ),
        
        Description:'eAdvisor is a enterprise dashboard and reports to visualize key metrics and data in one centralized location, allowing you to monitor and analyze information at a glance. Use our comprehensive reports to uncover trends, identify opportunities, and drive growth.',
        subMenu: [
          {
            id: `coln-1-collections`,
            label: 'DBaaS Programs',
            path: '/management/dbaas/programs',
            isEnabled:true,
            svg:(
              <svg className="h-6 w-6 mr-1"  fill="none" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
          <path stroke="currentColor" d="M4 26.016q0 1.632 1.6 3.008t4.384 2.176 6.016 0.8 6.016-0.8 4.384-2.176 1.6-3.008v-3.392q0 1.632-1.632 2.88t-4.32 1.856-6.048 0.64-6.048-0.64-4.32-1.856-1.632-2.88v3.392zM4 20q0 1.632 1.6 3.008t4.384 2.208 6.016 0.8 6.016-0.8 4.384-2.208 1.6-3.008v-3.36q0 1.6-1.632 2.848t-4.32 1.888-6.048 0.64-6.048-0.64-4.32-1.888-1.632-2.848v3.36zM4 14.016q0 1.632 1.6 3.008t4.384 2.176 6.016 0.8 6.016-0.8 4.384-2.176 1.6-3.008v-3.392q0 1.632-1.632 2.88t-4.32 1.856-6.048 0.64-6.048-0.64-4.32-1.856-1.632-2.88v3.392zM4 8q0 1.632 1.6 3.008t4.384 2.208 6.016 0.8 6.016-0.8 4.384-2.208 1.6-3.008v-1.984q0-1.632-1.6-3.008t-4.384-2.176-6.016-0.832-6.016 0.832-4.384 2.176-1.6 3.008v1.984z"/>
        </svg>
      
            ),
          },
          {
            id: `coln-1-collections`,
            label: 'DBaaS Subscriptions',
            path: '/management/dbaas/subscriptions',
            isEnabled:true,
            svg:(
              <svg viewBox="0 0 24 24"  className="h-6 w-6 mr-1"  fill="none"  xmlns="http://www.w3.org/2000/svg">
              <path stroke="currentColor" d="M18 2H6v2h12V2zM4 6h16v2H4V6zm-2 4h20v12H2V10zm18 10v-8H4v8h16z"/>
            </svg>
      
            ),
          },
        ],
      },
      {
        id: `main-menu-2-all`,
        path: '/management/dbaas/endpoints',
        label: 'InfraStructure Management',
        isEnabled:true,
        svg:(
          <svg className="h-6 w-6 mr-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="currentColor">
          <path d="M20,27H7a2,2,0,0,1-2-2V12h2v11H20Z"/>
          <path d="M23.4,22l-4-4a3.606,3.606,0,0,0,.6-2,4.012,4.012,0,0,0-4-4,3.606,3.606,0,0,0-2,.6l-4-4V2H2v8H8.6l4,4a3.606,3.606,0,0,0-.6,2,4.012,4.012,0,0,0,4,4,3.606,3.606,0,0,0,2-.6l4,4V30h8V22ZM8,8H4V4H8Zm8,10a2,2,0,1,1,2-2A2,2,0,0,1,16,18ZM28,28H24V24h4Z"/>
          <path d="M25,20h2V7a2,2,0,0,0-2-2H12V7H25Z"/>
        </svg>
  
        ),
        
        Description:'eAdvisor is a enterprise dashboard and reports to visualize key metrics and data in one centralized location, allowing you to monitor and analyze information at a glance. Use our comprehensive reports to uncover trends, identify opportunities, and drive growth.',
        subMenu: [
      //     {
      //       id: `coln-1-collections`,
      //       label: 'POP',
      //       path: '/management/platform-management/pop',
      //       isEnabled:true,
      //       svg:(
      //         <svg className="h-5 w-5 mr-1" 
      //        xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      //   <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 14v4.833A1.166 1.166 0 0 1 16.833 20H5.167A1.167 1.167 0 0 1 4 18.833V7.167A1.166 1.166 0 0 1 5.167 6h4.618m4.447-2H20v5.768m-7.889 2.121 7.778-7.778"/>
      // </svg>
      
      //       ),
      //     },
          {
            id: `coln-1-collections`,
            label: 'DBaas Endpoints',
            path: '/management/dbaas/endpoints',
            isEnabled:true,
            svg:(
              <svg className="h-6 w-6 mr-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="currentColor">
              <path d="M20,27H7a2,2,0,0,1-2-2V12h2v11H20Z"/>
              <path d="M23.4,22l-4-4a3.606,3.606,0,0,0,.6-2,4.012,4.012,0,0,0-4-4,3.606,3.606,0,0,0-2,.6l-4-4V2H2v8H8.6l4,4a3.606,3.606,0,0,0-.6,2,4.012,4.012,0,0,0,4,4,3.606,3.606,0,0,0,2-.6l4,4V30h8V22ZM8,8H4V4H8Zm8,10a2,2,0,1,1,2-2A2,2,0,0,1,16,18ZM28,28H24V24h4Z"/>
              <path d="M25,20h2V7a2,2,0,0,0-2-2H12V7H25Z"/>
            </svg>
      
            ),
          },
          {
            id: `coln-1-collections`,
            label: 'DBaas Environments',
            path: '/management/dbaas/environments',
            isEnabled:true,
            svg:(
              <svg className="h-6 w-6 mr-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="currentColor">
              <path d="M20,27H7a2,2,0,0,1-2-2V12h2v11H20Z"/>
              <path d="M23.4,22l-4-4a3.606,3.606,0,0,0,.6-2,4.012,4.012,0,0,0-4-4,3.606,3.606,0,0,0-2,.6l-4-4V2H2v8H8.6l4,4a3.606,3.606,0,0,0-.6,2,4.012,4.012,0,0,0,4,4,3.606,3.606,0,0,0,2-.6l4,4V30h8V22ZM8,8H4V4H8Zm8,10a2,2,0,1,1,2-2A2,2,0,0,1,16,18ZM28,28H24V24h4Z"/>
              <path d="M25,20h2V7a2,2,0,0,0-2-2H12V7H25Z"/>
            </svg>
      
            ),
          },
          {
            id: `coln-1-collections`,
            label: 'DBaas Phases',
            path: '/management/dbaas/phases',
            isEnabled:true,
            svg:(
              <svg className="h-6 w-6 mr-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="currentColor">
              <path d="M20,27H7a2,2,0,0,1-2-2V12h2v11H20Z"/>
              <path d="M23.4,22l-4-4a3.606,3.606,0,0,0,.6-2,4.012,4.012,0,0,0-4-4,3.606,3.606,0,0,0-2,.6l-4-4V2H2v8H8.6l4,4a3.606,3.606,0,0,0-.6,2,4.012,4.012,0,0,0,4,4,3.606,3.606,0,0,0,2-.6l4,4V30h8V22ZM8,8H4V4H8Zm8,10a2,2,0,1,1,2-2A2,2,0,0,1,16,18ZM28,28H24V24h4Z"/>
              <path d="M25,20h2V7a2,2,0,0,0-2-2H12V7H25Z"/>
            </svg>
      
            ),
          },
          {
            id: `coln-1-collections`,
            label: 'Digital Private Infrastructures',
            path: '/management/dbaas/digital-private-infrastructures',
            isEnabled:true,
            svg:(
               <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="9.379" cy="9.379" r="3.879"></circle>
              <circle cx="9.379" cy="38.621" r="3.879"></circle>
              <circle cx="9.379" cy="24" r="3.879"></circle>
              <rect x="17.4355" y="5.5" width="25.0645" height="7.7581" rx="1.7903" ry="1.7903"></rect>
              <rect x="17.4355" y="34.7419" width="25.0645" height="7.7581" rx="1.7903" ry="1.7903"></rect>
              <rect x="17.4355" y="20.121" width="25.0645" height="7.7581" rx="1.7903" ry="1.7903"></rect>
            </svg>
      
            ),
          },
          {
            id: `coln-1-collections`,
            label: 'Digital Public Infrastructures',
            path: '/management/dbaas/digital-public-infrastructures',
            isEnabled:true,
            svg:(
              <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="9.379" cy="9.379" r="3.879"></circle>
              <circle cx="9.379" cy="38.621" r="3.879"></circle>
              <circle cx="9.379" cy="24" r="3.879"></circle>
              <rect x="17.4355" y="5.5" width="25.0645" height="7.7581" rx="1.7903" ry="1.7903"></rect>
              <rect x="17.4355" y="34.7419" width="25.0645" height="7.7581" rx="1.7903" ry="1.7903"></rect>
              <rect x="17.4355" y="20.121" width="25.0645" height="7.7581" rx="1.7903" ry="1.7903"></rect>
            </svg>
      
            ),
          },
          {
            id: `coln-1-collections`,
            label: 'DBaas Services',
            path: '/management/dbaas/services',
            isEnabled:true,
            svg:(
              <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="9.379" cy="9.379" r="3.879"></circle>
              <circle cx="9.379" cy="38.621" r="3.879"></circle>
              <circle cx="9.379" cy="24" r="3.879"></circle>
              <rect x="17.4355" y="5.5" width="25.0645" height="7.7581" rx="1.7903" ry="1.7903"></rect>
              <rect x="17.4355" y="34.7419" width="25.0645" height="7.7581" rx="1.7903" ry="1.7903"></rect>
              <rect x="17.4355" y="20.121" width="25.0645" height="7.7581" rx="1.7903" ry="1.7903"></rect>
            </svg>
      
            ),
          },
        ],
      },
	])
  const [open, setOpen] = useState(items)
	const [isMore, setIsMore] = useState(false)
	const [subOpen, setSubOpen] = useState(subitems)
	const [menuOpen, setMenuOpen] = useState(menuitems)
	menus.map((item) => {
		items.push({ open: true, isActive: false })
		
	  })
	
	
	  const handleClickOutside = (event: MouseEvent) => {
		if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
		  let menu = [...open]
		  open?.map((obj: any, idx: any) => {
			// menu[idx].isActive = false
			menu[idx].open = true
		  })
		  setOpen(menu)
		  let menu1 = [...subOpen]
		  subOpen?.map((obj: any, idx: any) => {
			// menu1[idx].isActive = false
			menu1[idx].open = true
		  })
		  setSubOpen(menu1)
		  let menu2 = [...menuitems]
		  menuitems?.map((obj: any, idx: any) => {
			// menu2[idx].isActive = false
			menu2[idx].open = true
		  })
		  setMenuOpen(menu2)
		}
	  };
	const handleItemClick = (index:any) => {
		setActiveIndex(index === activeIndex ? null : index);
	  };
	  const handleSubItemClick = (index:any) => {
		setActiveSubIndex(index === activeSubIndex ? null : index);
	  };

    const handleSideBarView = () => {
      dispatch(settings.set({ sidebar: !sidebar }))
    }
  	const fetchLogo =()=>{

      const storeData = {
        logoDark : organizationLists?.result?.items[0]?.BrandMappings[0]?.Configurations?.Logos.filter((logo: any) => {
        return logo.Background === 'Light'
          }),
         logoLight:  organizationLists?.result?.items[0]?.BrandMappings[0]?.Configurations?.Logos.filter((logo: any) => {
          return logo.Background === 'Dark'
            }),
         storeName:  organizationLists?.result?.items[0]?.BrandMappings[0]?.Name,
         description:  organizationLists?.result?.items[0]?.BrandMappings[0]?.Description,
         favicon: organizationLists?.result?.items[0]?.BrandMappings[0]?.Configurations?.Favicons[0]?.Url || '/assets/img/logo.png'
        }
        setLogo(storeData)
    }
    useEffect(() => {
      if (storePersist?.get("organizationUnits")?.isSuccess) {
        fetchLogo()
      }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
        };
     
    }, [])
  
    const handleNavigate = (data: any) => {
      navigate(`${data}`)
    }
  
    const handleMenu = (index: any, index1: any) => {
      let menu = [...open]
      open?.map((obj: any, idx: any) => {
        if (idx == index) {
          menu[idx].open = !obj.open
          menu[idx].isActive = true
        }
        else {
          menu[idx].open = true
          menu[idx].isActive = false
        }
      })
      setOpen(menu)
    }
    const handleSubMenu = (e: any, index: any) => {
      e.stopPropagation()
      let menu = [...subOpen]
      subOpen?.map((obj: any, idx: any) => {
        if (idx == index) {
          menu[idx].open = !obj.open
          menu[idx].isActive = true
        }
        else {
          menu[idx].open = true
          menu[idx].isActive = false
        }
      })
      setSubOpen(menu)
    }
    const handleItems = (e: any, itemIndex: any) => {
      e.stopPropagation()
      let menu2 = [...menuitems]
      menuitems?.map((obj: any, idx: any) => {
        if (idx == itemIndex) {
          menu2[idx].isActive = true
          menu2[idx].open = !obj.open
        }
        else {
          menu2[idx].isActive = false
          menu2[idx].open = true
        }
      })
      setMenuOpen(menu2)
    }
  
    const beginWord = (sentence: string | undefined | null) => {
      if (!sentence || typeof sentence !== 'string') {
        return '';
      }
      const words = sentence.trim().split(/\s+/);
      if (words.length === 0) {
        return '';
      }
      if (sentence.length > 19) {
        const lastWord = words.pop() as string;
        let transformedSentence = ""
        if (words.length == 1) {
          transformedSentence = `${words[0]} `;
        }
        else if (words.length == 2)
          transformedSentence = `${words[0]} ${words[1]}`;
        return transformedSentence
      }
      else {
        return sentence
      }
    }
  
    const endWord = (sentence: string | undefined | null) => {
      if (!sentence || typeof sentence !== 'string') {
        return '';
      }
      const words = sentence.trim().split(/\s+/);
      if (words.length === 0) {
        return '';
      }
      if (sentence.length > 19) {
        const lastWord = words.pop() as string;
        return lastWord
      }
    }
  
    return (
      <>
        {sidebar ?     <div className={`w-64 fixed md:top-0 md:left-0 h-screen lg:block primary-${color} z-10 `}>
  
          {sidebar &&
            <div className={`w-full flex flex-col justify-end items-end p-2 pr-4 mt-20 lg:mt-20 md:mt-20`}>
              <svg
                onClick={() => dispatch(settings.set({ sidebar: !sidebar }))}
                width="22" height="22" viewBox="0 0 24 24" fill="none" className="cursor-pointer hover:stroke-hilight">
                  <title>Show Less Infomation</title>
                <path stroke-width="1.25" d="M12.6772 19.5377C12.9742 19.8265 13.449 19.8198 13.7377 19.5228C14.0265 19.2258 14.0198 18.751 13.7228 18.4623L12.6772 19.5377ZM6 12L5.47719 11.4623C5.33195 11.6035 5.25 11.7974 5.25 12C5.25 12.2026 5.33195 12.3965 5.47719 12.5377L6 12ZM13.7228 5.53775C14.0198 5.24901 14.0265 4.77418 13.7377 4.47719C13.449 4.1802 12.9742 4.17351 12.6772 4.46225L13.7228 5.53775ZM17.4772 18.3708C17.7742 18.6595 18.249 18.6528 18.5378 18.3558C18.8265 18.0588 18.8198 17.584 18.5228 17.2952L17.4772 18.3708ZM12 12L11.4772 11.4622C11.332 11.6035 11.25 11.7974 11.25 12C11.25 12.2026 11.332 12.3965 11.4772 12.5378L12 12ZM18.5228 6.70476C18.8198 6.41603 18.8265 5.9412 18.5378 5.64421C18.249 5.34721 17.7742 5.34051 17.4772 5.62924L18.5228 6.70476ZM13.7228 18.4623L6.52281 11.4623L5.47719 12.5377L12.6772 19.5377L13.7228 18.4623ZM6.52281 12.5377L13.7228 5.53775L12.6772 4.46225L5.47719 11.4623L6.52281 12.5377ZM18.5228 17.2952L12.5228 11.4622L11.4772 12.5378L17.4772 18.3708L18.5228 17.2952ZM12.5228 12.5378L18.5228 6.70476L17.4772 5.62924L11.4772 11.4622L12.5228 12.5378Z" fill="#f8f8f8" />
              </svg>
            </div>
          }
          <div className="h-[calc(100vh-10rem)] overflow-auto">
            <div className="mb-4  px-4 h-max ">
              {menus.map((obj: any, index1: any) => {
                return <li
                  onClick={() => handleMenu(index1, null)}
                  className={`w-full flex flex-col justify-start space-y-3 `}>
                  <div className={`flex flex-row justify-start rounded-r-lg px-2 cursor-pointer h-10 items-center hover:bg-secondary  dark:hover:text-black" ${open[index1]?.isActive ? "border-l-4 border-blue-500" : ""} `}>
                    {obj?.svg}
                    <span onClick={() => handleNavigate(obj?.path)} className="dark:hover:text-black w-36 text-sm ">{obj.label}</span>
                  </div>
                  {obj?.subMenu?.map((obj1: any, index2: any) => {
                    return <ul
                      onClick={(e) => handleSubMenu(e, index2)}
                      className={`w-full flex pl-2 flex-col justify-center space-y-3 ${open[index1]?.open ? 'hidden' : 'ml-2'} `}>
                      <div className={`flex flex-row justify-start  items-center  rounded-r-lg  px-2 cursor-pointer  h-10 hover:bg-secondary dark:hover:text-black"  ${subOpen[index2]?.isActive ? "border-l-4 border-blue-500" : ""}`}>
                        {obj1?.svg}
                        <div onClick={() => handleNavigate(obj1?.path)} className="primary-${color}  text-sm dark:text-slate-200 dark:hover:text-black w-36  flex flex-col w-auto justify-center items-end">
                          <span className="">{beginWord(obj1.label)}</span>
                          <span className="text-right text-xs italic">{endWord(obj1.label)}</span>
                        </div>
                      </div>
                      {obj1?.subMenu?.map((obj2: any, index3: any) => {
                        return <li
                          onClick={(e) => handleItems(e, index3)}
                          className={`w-full flex flex-col pl-2 justify-start space-y-3  ${subOpen[index2]?.open ? 'hidden' : 'ml-2'} `}>
                          <div className={`flex flex-row justify-start rounded-r-lg px-2 cursor-pointer h-10 items-center hover:bg-secondary dark:hover:text-black"  ${menuOpen[index3]?.isActive ? "border-l-4 border-blue-500" : ""}`}>
                            {obj2?.svg}
                            <div onClick={() => handleNavigate(obj2?.path)} className="text-sm dark:text-slate-200 dark:hover:text-black w-36 flex flex-col w-auto justify-center items-end">
                              <span className="">{beginWord(obj2.label)}</span>
                              <span className="text-right text-xs italic"> {endWord(obj2.label)}</span>
                            </div>
                          </div>
                        </li>
                      })}
                    </ul>
                  })}
                </li>
              })}
            </div>
          </div>
          </div> : <div ref={dropdownRef} className={`w-24 fixed md:top-0 md:left-0 h-screen lg:block primary-${color} z-10`} >
          <div className="">
            {!sidebar &&
              <div className={`w-full flex flex-col justify-end items-end p-2 mt-20 lg:mt-20 md:mt-20`}>
                <svg
                  onClick={() => dispatch(settings.set({ sidebar: !sidebar }))}
                  width="22" height="22" viewBox="0 0 24 24" fill="none" className="cursor-pointer hover:stroke-hilight">
                    <title>Show More Infomation</title>
                  <path stroke-width="1.25" d="M10.2772 18.4623C9.9802 18.751 9.97351 19.2258 10.2623 19.5228C10.551 19.8198 11.0258 19.8265 11.3228 19.5377L10.2772 18.4623ZM18 12L18.5228 12.5377C18.6681 12.3965 18.75 12.2026 18.75 12C18.75 11.7974 18.6681 11.6035 18.5228 11.4623L18 12ZM11.3228 4.46225C11.0258 4.17351 10.551 4.1802 10.2623 4.47719C9.97351 4.77418 9.9802 5.24901 10.2772 5.53775L11.3228 4.46225ZM5.47721 17.2952C5.18021 17.584 5.17351 18.0588 5.46224 18.3558C5.75097 18.6528 6.2258 18.6595 6.52279 18.3708L5.47721 17.2952ZM12 12L12.5228 12.5378C12.668 12.3965 12.75 12.2026 12.75 12C12.75 11.7974 12.668 11.6035 12.5228 11.4622L12 12ZM6.52279 5.62924C6.2258 5.34051 5.75097 5.34721 5.46224 5.64421C5.17351 5.9412 5.18021 6.41603 5.47721 6.70476L6.52279 5.62924ZM11.3228 19.5377L18.5228 12.5377L17.4772 11.4623L10.2772 18.4623L11.3228 19.5377ZM18.5228 11.4623L11.3228 4.46225L10.2772 5.53775L17.4772 12.5377L18.5228 11.4623ZM6.52279 18.3708L12.5228 12.5378L11.4772 11.4622L5.47721 17.2952L6.52279 18.3708ZM12.5228 11.4622L6.52279 5.62924L5.47721 6.70476L11.4772 12.5378L12.5228 11.4622Z" fill="#f8f8f8" />
                </svg>
              </div>
            }
            <div className="mb-4 px-4 h-max ">
              <ul className="w-full flex flex-col justify-start space-y-3">
                {!isMore && menus.map((barmenu: any, index1: any) => {
                  return <li
                    className={`flex items-center h-10 ${open[index1]?.isActive ? "border-l-4 border-blue-500" : ""} ${index1 > 8 ? 'hidden' : ""} `}
                    onClick={() => handleMenu(index1, null)} >
                    <div className={`flex flex-row justify-start  rounded-lg  px-4  cursor-pointer  h-10 items-center hover:bg-secondary  max-w-24   dark:hover:text-black"`}>
                      {barmenu?.svg}
                    </div>
                    <ul className={`flex flex-col space-y-3 items-center  max-h-[300px] max-w-56 overflow-auto justify-start  py-5 px-3  primary-${color} ml-0 ${index1 > 4 ? "mt-[calc(100vh-60rem)]" : "mt-auto"} rounded-r-xl min-w-64  font-medium text-sm  "  ${open[index1]?.open ? 'hidden' : 'ml-4'}`}>
                      {barmenu?.subMenu?.map((obj1: any, index2: any) => {
                        return <ul
                          onClick={(e) => handleSubMenu(e, index2)}
                          className={`w-full flex pl-2 flex-col  justify-center space-y-3 ${open[index1]?.open ? 'hidden' : 'pl-2'} `}>
                          <div className={`flex flex-row justify-start  items-center  rounded-r-lg  px-2 cursor-pointer  h-10 hover:bg-secondary dark:hover:text-black"  ${subOpen[index2]?.isActive ? "border-l-4 border-blue-500" : ""}`}>
                            {obj1?.svg}
                            <div onClick={() => handleNavigate(obj1?.path)} className="primary-${color}  text-sm dark:text-slate-200 dark:hover:text-black   flex flex-col w-auto justify-center items-end">
                              <span className="">{beginWord(obj1.label)}</span>
                              <span className="text-right text-xs italic">{endWord(obj1.label)}</span>
                            </div>
                          </div>
                          {obj1?.subMenu?.map((obj2: any, index3: any) => {
                            return <li
                              onClick={(e) => handleItems(e, index3)}
                              className={`w-full flex flex-col pl-2 justify-start space-y-3  ${subOpen[index2]?.open ? 'hidden' : 'ml-2'} `}>
                              <div className={`flex flex-row justify-start rounded-r-lg px-2 cursor-pointer h-10 items-center hover:bg-secondary dark:hover:text-black"  ${menuOpen[index3]?.isActive ? "border-l-4 border-blue-500" : ""}`}>
                                {obj2?.svg}
                                <div onClick={() => handleNavigate(obj2?.path)} className="text-sm dark:text-slate-200 dark:hover:text-black w-36 flex flex-col w-auto justify-center items-end">
  
                                  <span className="">{beginWord(obj2.label)}</span>
                                  <span className="text-right text-xs italic"> {endWord(obj2.label)}</span>
                                </div>
                              </div>
                            </li>
                          })}
                        </ul>
                      })}
                    </ul>
                  </li>
                })}
                {isMore && menus.map((barmenu: any, index1: any) => {
                  return <li
                    className={`flex items-center h-10 ${open[index1]?.isActive ? "border-l-4 border-blue-500" : ""} ${index1 < 8 ? 'hidden' : ""} `}
                    onClick={() => handleMenu(index1, null)} >
                    <div className={`flex flex-row justify-start  rounded-lg  px-4  cursor-pointer  h-10 items-center hover:bg-secondary  max-w-24   dark:hover:text-black"`}>
                      {barmenu?.svg}
                    </div>
                    <ul className={`flex flex-col space-y-3 items-center  max-h-[300px] max-w-56 overflow-auto justify-start  py-5 px-3  bg-primary dark:bg-slate-800 ml-0 ${index1 > 12 ? "mt-[calc(100vh-60rem)]" : "mt-auto"} rounded-r-xl min-w-64  font-medium text-sm  "  ${open[index1]?.open ? 'hidden' : 'ml-4'}`}>
                      {barmenu?.subMenu?.map((obj1: any, index2: any) => {
                        return <ul
                          onClick={(e) => handleSubMenu(e, index2)}
                          className={`w-full flex pl-2 flex-col  justify-center space-y-3 ${open[index1]?.open ? 'hidden' : 'pl-2'} `}>
                          <div className={`flex flex-row justify-start  items-center  rounded-r-lg  px-2 cursor-pointer  h-10 hover:bg-secondary dark:hover:text-black"  ${subOpen[index2]?.isActive ? "border-l-4 border-blue-500" : ""}`}>
                            {obj1?.svg}
                            <div onClick={() => handleNavigate(obj1?.path)} className="primary-${color} text-sm dark:text-slate-200 dark:hover:text-black   flex flex-col w-auto justify-center items-end">
                              <span className="">{beginWord(obj1.label)}</span>
                              <span className="text-right text-xs italic">{endWord(obj1.label)}</span>
                            </div>
                          </div>
                          {obj1?.subMenu?.map((obj2: any, index3: any) => {
                            return <li
                              onClick={(e) => handleItems(e, index3)}
                              className={`w-full flex flex-col pl-2 justify-start space-y-3  ${subOpen[index2]?.open ? 'hidden' : 'ml-2'} `}>
                              <div className={`flex flex-row justify-start rounded-r-lg px-2 cursor-pointer h-10 items-center hover:bg-secondary dark:hover:text-black"  ${menuOpen[index3]?.isActive ? "border-l-4 border-blue-500" : ""}`}>
                                {obj2?.svg}
                                <div onClick={() => handleNavigate(obj2?.path)} className="text-sm dark:text-slate-200 dark:hover:text-black w-36 flex flex-col w-auto justify-center items-end">
                                  <span className="">{beginWord(obj2.label)}</span>
                                  <span className="text-right text-xs italic"> {endWord(obj2.label)}</span>
                                </div>
                              </div>
                            </li>
                          })}
                        </ul>
                      })}
                    </ul>
                  </li>
                })}
              </ul>
            </div>
          </div>
          {/* <div
            onClick={() => setIsMore(!isMore)}
            className="w-24 text-xs text-right px-4 text-blue-500 underline cursor-pointer">
            {!isMore ? 'More' : 'Less'}
          </div> */}
        </div>}
      </>
    )
  }
  
  export default Sidebar;

